<template>
    <div class="field" style="padding-right: 15px;">
        <button class="button is-info" @click="openBidModal(bid.lot_id)">Update Bid</button>
        <button class="button is-black is-outlined" disabled>Group: {{ bid.group.name }} Max wins: {{ bid.group.max_wins }} Position: {{ bid.position }}</button>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {

            }
        },
        methods: {
            openBidModal(lotId) {
                this.$store.dispatch('changeBidModalStatus', { status: true, lotId: lotId })
                this.$store.dispatch('fetchGroups', {date: this.bid.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeCurrentBidLotId', this.bid.lot_id)
                this.$store.dispatch('changePlaceBidLoadingStatus', true)
                if (this.bid.bids.length > 0 === true) {
                    apiBids
                        .bidRequest(bid.id)
                        .then((response) => {
                            console.log(response.data)
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                            this.$store.dispatch('changeCurrentBidId', response.data.id)
                            this.$store.dispatch('changeCurrentBidStatus', response.data.status)
                            this.$store.dispatch('changeCurrentBidGroup', response.data.group)
                            this.$store.dispatch('changeSelectedGroup', response.data.group)

                        })
                        .catch((err) => {
                            console.log(err.response)
                            this.$store.dispatch('changePlaceBidLoadingStatus', false)
                            this.$store.dispatch('changeBidError', {field: 'status', value: true})
                            this.$store.dispatch('changeBidError', {field: 'message', value: err.response.data.bid})
                        })
                }
            }
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Bids/BidUpdate.vue